import styled from '@emotion/styled'

export const SVGWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    max-width: ${(props) => props.maxWidth};
  }
`
